// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__96Zo-"};